import websiteTypes from './websites.types';
import {
  getCurrentWebsite,
  getNewWebsite,
  handleOperatorsAssignment,
} from './websites.utils';

export const INITIAL_STATE = {
  currentWebsite: {},
  websites: {
    loading: false,
    data: null,
  },
  whatsappBarcode: {
    loading: false,
    data: null,
    alreadyLoggedIn: false,
  },
  permissionWhatsapp: false,
  agentAssignByUrl: false,
  containersTeam: {},
  data: null,
  isFetching: false,
  error: null,
  selectedWorkspace: null,
};

const websitesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case websiteTypes.SET_SELECTED_WORKSPACE:
      return {
        ...state,
        selectedWorkspace: action.payload,
      };
    case websiteTypes.FETCH_WEBSITES_START_SUCCESS:
      return {
        ...state,
        isFetching: true,
        data: action.payload,
      };
    case websiteTypes.FETCH_WEBSITES_START_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    case websiteTypes.ADD_NEW_WEBSITE:
      return {
        ...state,
        websites: [
          ...state.websites,
          getNewWebsite({
            prevState: state,
            websiteToAdd: action.payload,
          }),
        ],
      };
    case websiteTypes.SET_WEBSITES:
      return {
        ...state,
        websites: {
          loading: false,
          data: action.payload,
        },
      };
    case websiteTypes.LOADING_WEBSITES:
      return {
        ...state,
        websites: {
          ...state.websites,
          loading: true,
        },
      };
    case websiteTypes.SET_WEBSITE_STATUS:
      return {
        ...state,
        websites: {
          ...state.websites,
          data: state.websites.data.map((website) => {
            return action.payload.id === website.id
              ? {
                  ...website,
                  isActive: action.payload.isActive,
                }
              : website;
          }),
        },
      };
    case websiteTypes.SET_CURRENT_WEBSITE:
      return {
        ...state,
        currentWebsite: getCurrentWebsite({
          prevState: state,
          websiteId: action.payload,
        }),
      };
    case websiteTypes.UPDATE_WEBSITE_OPERATOR_LIST:
      return {
        ...state,
        websites: handleOperatorsAssignment({
          prevState: state,
          selectedOperatorsIds: action.payload,
        }),
      };

    case websiteTypes.SET_WHATSAPP_BARCODE:
      return {
        ...state,
        whatsappBarcode: {
          loading: false,
          data: action.payload.barcode,
          alreadyLoggedIn: !!action.payload.alreadyLoggedIn,
        },
      };
    case websiteTypes.LOADING_WHATSAPP_BARCODE:
      return {
        ...state,
        whatsappBarcode: {
          ...state.whatsappBarcode,
          loading: true,
        },
      };
    case websiteTypes.SET_PERMISSION_WHATSAPP:
      return {
        ...state,
        permissionWhatsapp: action.payload,
      };
    case websiteTypes.UPDATE_CONTAINER_TEAM:
      return {
        ...state,
        containersTeam: {
          ...state.containersTeam,
          [action.payload.container_id]: action.payload.team,
        },
      };

    case websiteTypes.SET_CHANNELS_TEAM:
      return {
        ...state,
        containersTeam: action.payload,
      };

    case websiteTypes.SET_AGENT_ASSIGN_BY_URL:
      return {
        ...state,
        agentAssignByUrl: action.payload,
      };
    case websiteTypes.DELETE_WEBSITE_SUCCESS:
      return {
        ...state,
        isFetching: true,
        data: action.payload,
      };
    case websiteTypes.DELETE_WEBSITE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    case websiteTypes.RESET_WEBSITES_STATE:
      return {
        ...state,
        websites: {
          loading: false,
          data: null,
        },
        selectedWorkspace: null,
      };
    default:
      return state;
  }
};

export default websitesReducer;
